// extracted by mini-css-extract-plugin
export var hero = "category-module--hero---O1e7";
export var heroText = "category-module--heroText--2vH9N";
export var container = "category-module--container--qIhq4";
export var pager = "category-module--pager--1nVZM";